import { useQuery } from '@tanstack/react-query';

import { z } from 'zod';
import useAuthenticatedFetch from '@/domains/auth/hooks/authenticatedFetch';
import { isNative } from '@/domains/shared/utils/native';

const minimumAppVersionResponseSchema = z.object({
  minimumAppVersion: z.string(),
});

type MinimumAppVersionResponse = z.infer<
  typeof minimumAppVersionResponseSchema
>;

export const useMinimumAppVersionQuery = () => {
  const authenticatedFetch = useAuthenticatedFetch();
  return useQuery<MinimumAppVersionResponse>({
    queryKey: ['minimumAppVersion'],
    enabled: isNative(),
    queryFn: async () => {
      const data = await authenticatedFetch(
        '/api/app-bootstrap/minimum-app-version',
        {
          method: 'GET',
        },
      );
      return minimumAppVersionResponseSchema.parse(await data.json());
    },
  });
};
